import { render } from "./PageAbout.vue?vue&type=template&id=794959b0"
import script from "./PageAbout.vue?vue&type=script&lang=js"
export * from "./PageAbout.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mda/www/akademia-taletow/spa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__